import { Component, computed, inject } from '@angular/core';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';

@Component({
    selector: 'app-count-not-interested-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-not-interested-packages.component.html',
    standalone: true,
    styleUrl: './count-not-interested-packages.component.scss'
})
export class CountNotInterestedPackagesComponent {

    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    requestedPackagesCountResult = toSignal(
        this._packageService.countPackageResponses('not_interested').pipe(
            catchError(() => of(null))
        )
    );

    requestedPackages = computed(() => this.requestedPackagesCountResult()?.count);

    getPackageCount(): number {
        return this.requestedPackages() && Number(this.requestedPackages()) > 0 ? Number(this.requestedPackages()) : 0;
    }

}
